import { useEffect } from 'react';
import { withAllBranches } from '../../../../../helpers/mappers';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useDishMenuStore } from '../../../../../store/use-dish-menu-store';
import { useDishStore } from '../../../../../store/use-dish-store';
import { IdValue } from '../../../../../types/props';

export const useMenuInformer = () => {
  const { t, currentLang } = useLang();
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const branchId = params.branchId;
  const menuId = params.menuId;

  const { deleteDish } = useDishStore();
  const { menuList, fetchMenuList, handleResetMenu, isLoading: isLoadingMenu } = useDishMenuStore();

  const filteredMenuList = branchId
    ? menuList?.filter((item) => Number(branchId) === item.place_id)
    : menuList;

  const { place, fetchBranches } = useBranchesStore();
  const branches = withAllBranches(place, currentLang);

  const selectedBranch = branches?.find((branch) => branch.id === branchId);
  const selectedMenu = filteredMenuList?.find((menu) => menu.id === menuId);

  useEffect(() => {
    fetchBranches({ is_by_company: true, since_id: 0, n: 1000 });
    fetchMenuList({ is_by_company: true, since_id: 0, n: 1000 });
  }, []);

  const handleSelectBranch = (data: IdValue) => {
    addQueryParams({ branchId: data.id, menuId: undefined });
  };

  const handleCreateMenu = () => {
    handleResetMenu();
    addQueryParams({ menuId: undefined, modalId: 'createMenu' });
  };

  return {
    t,
    menuList: filteredMenuList,
    isLoadingMenu,

    handleCreateMenu,

    deleteDish,
    selectedMenu,
    branches,
    selectedBranch,
    handleSelectBranch,
    branchId,
  };
};
